module.exports = __webpack_public_path__ + "img/stripe-logo.5581909a.svg";